import React, { Component } from 'react'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import { DropTarget, DragSource } from 'react-dnd'
import ItemTypes from '~/utils/TemplateEditor/dragDropItemTypes'
import { findDOMNode } from 'react-dom'
import i18n from '~/i18n'
import HolderOptions from '~/Common-Objects/TemplateEditor/DragDropStage/Shared/holderOptions.jsx'
import tableRows from './tableRows'
import DragHolder from '~/Common-Objects/TemplateEditor/DragDropStage/Shared/dragHolder.jsx'
import {
    NESTED_HOVER_EVENT,
    NESTED_UNHOVER_EVENT,
    notifyAncestorsNestedHover,
    notifyAncestorsNestedUnhover
} from '~/Common-Objects/TemplateEditor/DragDropStage/Shared/nestedHover'
import { claimActiveHover, releaseActiveHover } from '~/Common-Objects/TemplateEditor/DragDropStage/Shared/activeHover'
import { setActiveDragTuuid, isActiveDragTuuid } from '~/Common-Objects/TemplateEditor/DragDropStage/Shared/activeDrag'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import FileManager from '~/pages/cp/includes/fileManager/fileManager'
import { connect } from 'react-redux'
import { computeHolderChrome, isHolderNested } from '~/Common-Objects/TemplateEditor/DragDropStage/Shared/holderChrome'
import { cn } from '~/utils/cn'
import TemplateEditorUtils from '~/Common-Objects/TemplateEditor/Utils'
const dragSource = {
    beginDrag(props, monitor) {
        setActiveDragTuuid(props.elementData && props.elementData.tuuid)
        if (props.clearDragCache) props.clearDragCache()
        return { path: props.path }
    },
    endDrag(props) {
        setActiveDragTuuid(null)
        if (props.clearDragCache) props.clearDragCache()
    }
}

const dropSource = {
    drop() {
        return {}
    },
    hover(props, monitor, component) {
        const currentElementType = monitor.getItemType()

        if (monitor.isOver({ shallow: true }) === false) {
            return
        }

        if (currentElementType === 'newItem' && monitor.getItem().isNew === 0) {
            const currentElementPath = monitor.getItem().path
            const currentElementContent = monitor.getItem().content
            const hoveredElementPath = props.path
            if (!currentElementContent.tuuid) {
                currentElementContent.tuuid = DragDropFunctions.createGUID()
            }

            var newIndex =
                Number(
                    hoveredElementPath.substring(hoveredElementPath.lastIndexOf('[')).replace('[', '').replace(']', '')
                ) + 1
            var newPath =
                hoveredElementPath.substring(0, hoveredElementPath.lastIndexOf('.')) + '.elements[' + newIndex + ']'

            monitor.getItem().path = newPath
            monitor.getItem().isNew = 1
            props.insertElement(hoveredElementPath, currentElementContent, false)
            return
        }

        if (
            currentElementType === 'canvasItem' ||
            (currentElementType === 'newItem' && monitor.getItem().isNew === 1)
        ) {
            const currentElementPath = monitor.getItem().path
            const hoveredElementPath = props.path

            if (currentElementPath === hoveredElementPath) {
                return
            }

            const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            const clientOffset = monitor.getClientOffset()
            const hoverClientY = clientOffset.y - hoverBoundingRect.top

            const direction = DragDropFunctions.movingUpDown(currentElementPath, hoveredElementPath)

            // Dragging downwards
            if (direction == 1 && hoverClientY < hoverMiddleY) {
                return
            }

            // // Dragging upwards
            if (direction == -1 && hoverClientY > hoverMiddleY) {
                return
            }
            if (props.moveElement(currentElementPath, hoveredElementPath, false) !== false) {
                monitor.getItem().path = hoveredElementPath
            }
        }
    }
}

@connect((store) => {
    return { user: store.user, accountMaster: store.accountMaster }
})
@DropTarget([ItemTypes.CANVASITEM, ItemTypes.NEWITEM], dropSource, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
    isAnyDragActive: !!monitor.getItemType()
}))
@DragSource(ItemTypes.CANVASITEM, dragSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview()
}))
export default class TableItemHolder extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mouseOver: false,
            nestedHoverCount: 0,
            isNestedHolder: false,
            isFirstElement: false
        }
        this.clickHolder = this.clickHolder.bind(this)
        this.mouseEnter = this.mouseEnter.bind(this)
        this.mouseLeave = this.mouseLeave.bind(this)
        this.handleNestedHover = this.handleNestedHover.bind(this)
        this.handleNestedUnhover = this.handleNestedUnhover.bind(this)
        this.clearHoverState = this.clearHoverState.bind(this)
        this.isFirstElement = this.isFirstElement.bind(this)
        this.onFileClick = this.onFileClick.bind(this)
        this.nestedHoverNotified = false
        this.holderEl = null
    }

    handleNestedHover() {
        this.setState((state) => ({ nestedHoverCount: state.nestedHoverCount + 1 }))
    }

    handleNestedUnhover() {
        this.setState((state) => ({ nestedHoverCount: Math.max(0, state.nestedHoverCount - 1) }))
    }

    clearHoverState() {
        releaseActiveHover(this)
        if (this.nestedHoverNotified) {
            notifyAncestorsNestedUnhover(this.holderEl)
            this.nestedHoverNotified = false
        }
        if (this.state.mouseOver || this.state.nestedHoverCount) {
            this.setState({ mouseOver: false, nestedHoverCount: 0 })
        }
    }

    componentDidMount() {
        this.isFirstElement()
        this.holderEl = findDOMNode(this)
        if (this.holderEl) {
            this.holderEl.addEventListener(NESTED_HOVER_EVENT, this.handleNestedHover)
            this.holderEl.addEventListener(NESTED_UNHOVER_EVENT, this.handleNestedUnhover)
        }
    }
    componentWillUnmount() {
        releaseActiveHover(this)
        if (this.holderEl) {
            this.holderEl.removeEventListener(NESTED_HOVER_EVENT, this.handleNestedHover)
            this.holderEl.removeEventListener(NESTED_UNHOVER_EVENT, this.handleNestedUnhover)
        }
        if (this.nestedHoverNotified) {
            notifyAncestorsNestedUnhover(this.holderEl)
            this.nestedHoverNotified = false
        }
    }

    clickHolder(event) {
        let okToContinue = TemplateEditorUtils.checkMouseUpHasSelection(event, 'tableItemHolder')
        if (!okToContinue) {
            return
        }
        event.stopPropagation()
        if (this.props?.elementData?.ComponentId == 2) {
            //Image
            if (this.props?.selectedElement?.isSelected && this.props?.selectedElement?.path == this.props?.path) {
                let isPlaceHolder =
                    this.props.elementData.localVariables.imageSrc.value.indexOf(
                        '/siteContent/assets/templates/common/image-placeholder.png'
                    ) > -1
                if (isPlaceHolder) {
                    var theDrawer = <FileManager onFileClick={this.onFileClick} fileTypes={'images'} />
                    this.props.dispatch(
                        siteMaster.alterSiteDrawer(true, true, 'right', theDrawer, true, '100vw', 'fix-height')
                    )
                }
            }
        }
        this.props.clickElement(this.props.path)
    }

    async onFileClick(newFile) {
        this.props.elementData.localVariables.imageSrc.value = newFile.url
        this.props.elementData.localVariables.fileSize.value = newFile.size
        this.props.elementData.localVariables.srcImageWidth.value = newFile.imageWidth || 0
        this.props.elementData.localVariables.srcImageHeight.value = newFile.imageHeight || 0
        this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null, true, null))
        this.props.clickElement(undefined)
        await new Promise((resolve) => setTimeout(resolve, 100))
        this.props.clickElement(this.props.path)
    }

    mouseEnter(event) {
        event.stopPropagation()
        if (this.props.isAnyDragActive) return
        claimActiveHover(this, event.currentTarget, this.clearHoverState)
        if (!this.nestedHoverNotified) {
            notifyAncestorsNestedHover(event.currentTarget)
            this.nestedHoverNotified = true
            this.holderEl = event.currentTarget
        }
        this.setState({ mouseOver: true, isNestedHolder: isHolderNested(event.currentTarget) })
    }
    mouseLeave() {
        this.clearHoverState()
    }

    componentDidUpdate(prevProps) {
        const isCurrentlyDragging = this.props.isDragging || this.props.isAnyDragActive
        const wasDragging = prevProps.isDragging || prevProps.isAnyDragActive
        if (isCurrentlyDragging != wasDragging) {
            this.props.setDragging(isCurrentlyDragging)
        }
        const isThisDrag =
            this.props.isDragging || isActiveDragTuuid(this.props.elementData && this.props.elementData.tuuid)
        if (isCurrentlyDragging && !isThisDrag && (this.state.mouseOver || this.nestedHoverNotified)) {
            this.clearHoverState()
        }
    }

    isFirstElement() {
        try {
            let pathJson = this.props.path.split('.')
            let foundNotFirst = false
            for (let i = 1; i < pathJson.length; i++) {
                if (pathJson[i] !== 'elements[0]') {
                    foundNotFirst = true
                    break
                }
            }
            if (!foundNotFirst) {
                this.setState({ isFirstElement: true })
            } else {
                this.setState({ isFirstElement: false })
            }
        } catch (err) {
            console.log(err)
        }
    }

    render() {
        const {
            canDrop,
            isOver,
            connectDropTarget,
            connectDragSource,
            isDragging,
            moveElement,
            connectDragPreview,
            isDragActive
        } = this.props

        var activeDrag = isActiveDragTuuid(this.props.elementData && this.props.elementData.tuuid)
        var { isSelected, showChrome, showControls, showOutline, showDragBar } = computeHolderChrome({
            mouseOver: this.state.mouseOver,
            nestedHoverCount: this.state.nestedHoverCount,
            isNestedHolder: this.state.isNestedHolder,
            path: this.props.path,
            selectedPath: this.props.selectedElement.path,
            isDragging,
            isAnyDragActive: this.props.isAnyDragActive,
            activeDrag
        })
        var isSelectedClass = cn(
            isSelected && 'dndEditorv2-elementHolder--selected',
            showOutline && 'dndEditorv2-elementHolder--hovered',
            showChrome && 'dndEditorv2-elementHolder--chrome',
            this.props.showGuideLines && 'dndEditorv2-showGuideLines'
        )
        var eleProps
        if (this.props.elementData.props) {
            eleProps = DragDropFunctions.generatePropsForStage(
                this.props.elementData.props,
                this.props.globalVariables,
                'table',
                this.props.localVariables
            )
        }

        let clonable = true
        if (this.props.elementData.disableClone) clonable = false

        let elementHolderStyle = {}
        if (this.state.isFirstElement) {
            elementHolderStyle.marginTop = '20px'
            elementHolderStyle.marginBottom = '20px'
        }
        return connectDropTarget(
            connectDragPreview(
                <div
                    className={cn('dndEditorv2-elementHolder', isSelectedClass)}
                    // style={elementHolderStyle}
                    onClick={this.clickHolder}
                    onMouseEnter={this.mouseEnter}
                    onMouseLeave={this.mouseLeave}
                    data-eletuuid={this.props.elementData.tuuid}
                >
                    {/* <div className={'dndEditorv2-elementHolderTools ' + isSelectedClass}></div> */}
                    <div className={'dndEditorv2-elementHolderTools'}>
                        {showControls && (
                            <HolderOptions
                                path={this.props.path}
                                copyElement={this.props.copyElement}
                                deleteElement={this.props.deleteElement}
                                saveBlock={undefined}
                                canDelete={true}
                                user={this.props.user}
                                moveElementUp={this.props.moveElementUp}
                                moveElementDown={this.props.moveElementDown}
                                elementData={this.props.elementData}
                                elementsData={this.props.elementsData}
                                isLandingPage={this.props.isLandingPage}
                            />
                        )}

                        {showDragBar && (
                            <div
                                className={'dndEditorv2-ui-dd-drag-bar'}
                                alt={i18n.t('templates:add.drag.block.move')}
                                title={i18n.t('templates:add.drag.block.move')}
                            >
                                <div
                                    className={
                                        'dndEditorv2-ui-dd-tools-dragbar' +
                                        (this.state.isFirstElement ? ' dndEditorv2-ui-dd-tools-dragbar-first' : '')
                                    }
                                >
                                    <DragHolder
                                        element={this.props.elementData}
                                        connectDragSource={connectDragSource}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        {this.state.isFirstElement && showDragBar && <div style={{ height: '20px' }}></div>}
                        <table {...eleProps}>{tableRows(this.props.children)}</table>
                    </div>
                </div>,
                { anchorX: 0.5, anchorY: 0.5 }
            )
        )
    }
}
